import {pageInitializationActionTypes} from './../consts';

import boFetch from './../utils/request';
import {setUserProperties} from './../utils/userProfile';
import {setPropertiesByLocale} from './../utils/i18n';

const actionTypes = Object.entries(pageInitializationActionTypes).reduce((previous, next) => Object.assign(previous, {[next[1]]: next[0]}), {});

const initialize = () => {
    return (dispatch, getState) => {
        dispatch({type: actionTypes.start});
        boFetch({
            url: '/bo/userProfile',
            redirectUnauthorized: true
        }).then(json => {
            setUserProperties(json);
            return setPropertiesByLocale(json.locale);
        }).then(() => {
            dispatch({type: actionTypes.success});
            window && window.console && window.console.log(getState());
        }).catch(e => {
            (e.response || {}).status !== 401 && dispatch({type: actionTypes.fail});
            window && window.console && window.console.log(e);
        });
    }
};

export default initialize;


// WEBPACK FOOTER //
// ./src/app/actions/pageInitializationStatus.js